/** Standard Actions configuration for Dawn. */
const DAWN_CART_TAGS = ['cart-drawer', 'cart-items', 'cart-drawer-items', 'cart-notification'];
const DAWN_PUBSUB_REFRESHED_SECTIONS = new Set(['cart-drawer:cart-drawer','cart-drawer-items:CartDrawer','cart-items:main-cart-items']);

function collectCartSections() {
  const sections = new Map();
  for (const el of document.querySelectorAll(DAWN_CART_TAGS.join(','))) {
    let entries;
    try { entries = el.getSectionsToRender?.(); } catch { continue; }
    const tag = el.tagName.toLowerCase();
    for (const entry of entries ?? []) {
      if (DAWN_PUBSUB_REFRESHED_SECTIONS.has(`${tag}:${entry.id}`)) continue;
      const sectionId = entry.section ?? entry.id;
      if (!sectionId || sections.has(sectionId)) continue;
      const root = entry.section ? document.getElementById(entry.id) : document;
      if (!root) continue;
      const mount = entry.selector ? (root.querySelector(entry.selector) ?? (entry.section ? root : null)) : document.getElementById(entry.id);
      if (!mount) continue;
      sections.set(sectionId, { mount, extractSelector: entry.selector || '.shopify-section' });
    }
  }
  return sections;
}

async function refreshDawnCartUI() {
  const sections = collectCartSections();
  const sectionsQuery = sections.size ? `?sections=${[...sections.keys()].join(',')}` : '';
  const cartUrl = (typeof routes !== 'undefined' && routes?.cart_url) || '/cart';
  const cartData = await fetch(`${cartUrl}.js${sectionsQuery}`, { headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : null)).catch(() => null);
  if (cartData?.sections) {
    for (const [id, { mount, extractSelector }] of sections) {
      const html = cartData.sections[id];
      if (!html) continue;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(extractSelector);
      if (source) mount.replaceChildren(...source.childNodes);
    }
  }
  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external-refresh', cartData: cartData ?? undefined });
}

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;
  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      return defaultHandler();
    },
  });
  actions.updateCart.configure({
    eventTarget: () => document,
    async handler(defaultHandler) {
      const result = await defaultHandler();
      try { await refreshDawnCartUI(); }
      catch (error) { console.error('[Dawn] Standard Actions cart refresh failed; reloading.', error); window.location.reload(); }
      return result;
    },
  });
}
if (window.Shopify?.actions) initStandardActions();
else document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });

/* DAYVEE KI-KENNZEICHNUNG */
(() => {
  const STYLE_ID = 'dayvee-ai-badges-style';
  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .dv-wirkstoffe__ai-badge{top:auto!important;left:auto!important;right:10px!important;bottom:8px!important;min-height:0!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;font-size:13px!important;line-height:1.3!important;font-weight:600!important;letter-spacing:0!important;box-shadow:none!important;opacity:.95!important;white-space:nowrap!important;text-shadow:0 1px 2px rgba(255,255,255,.20)!important}
      .dayvee-ingredient__tag--one{font-size:calc(var(--dayvee-ki-font-size,11px) + 1px)!important;opacity:min(1,calc(var(--dayvee-ki-opacity,.75) + .15))!important;color:color-mix(in srgb,var(--dayvee-ki-text-color,#172826) 70%,#000 30%)!important;text-shadow:0 1px 2px rgba(255,255,255,calc(var(--dayvee-ki-shadow-opacity,.45) * .25))!important}
      @media screen and (max-width:749px){.dv-wirkstoffe__ai-badge{right:8px!important;bottom:6px!important;font-size:11px!important}.dayvee-ingredient__tag--one{font-size:calc(var(--dayvee-ki-font-size-mobile,10px) + 1px)!important}}
    `;
    document.head.appendChild(style);
  };
  const normalize = (root = document) => {
    root.querySelectorAll('.dv-wirkstoffe__ai-badge,.dayvee-ingredient__tag--one').forEach((label) => {
      const text = (label.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Mit KI erstellt') label.textContent = 'Bild mit KI erstellt';
    });
  };
  const init = (root = document) => { injectStyles(); normalize(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target || document));
})();

/* DAYVEE ACCESSIBILITY FOUNDATION */
(() => {
  const STYLE_ID = 'dayvee-accessibility-foundation-style';
  let idCounter = 0;

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .section-dayvee-header :where(a,button,summary):focus-visible,.section-dayvee-mega-menu :where(a,button,summary):focus-visible,[class*="section-dayvee-"] :where(a,button,summary):focus-visible,[id^="dayvee-"] :where(a,button,summary):focus-visible{outline:2px solid #fff!important;outline-offset:2px!important;box-shadow:0 0 0 4px #0058bd!important}
      .section-dayvee-header .dyh-search-input:focus-visible,.section-dayvee-newsletter-split .dns-input:focus-visible{outline:2px solid #fff!important;outline-offset:1px!important;box-shadow:0 0 0 4px #0058bd!important}
      @media (prefers-reduced-motion:reduce){[class*="section-dayvee-"] *,[id^="dayvee-"] *{scroll-behavior:auto!important;transition-duration:.01ms!important;animation-duration:.01ms!important;animation-iteration-count:1!important}}
    `;
    document.head.appendChild(style);
  };

  const appendDescribedBy = (element, id) => {
    if (!element || !id) return;
    const ids = (element.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (!ids.includes(id)) ids.push(id);
    element.setAttribute('aria-describedby', ids.join(' '));
  };

  const enhanceNewsletter = (root = document) => {
    root.querySelectorAll('.dns-form-el').forEach((form) => {
      const input = form.querySelector('.dns-input[type="email"]');
      if (!input) return;
      if (!input.id) {
        const section = input.closest('[id^="dayvee-newsletter-split-"]');
        idCounter += 1; input.id = `${section?.id || 'dayvee-newsletter'}-email-${idCounter}`;
      }
      const hasLabel = Array.from(form.querySelectorAll('label')).some((label) => label.htmlFor === input.id);
      if (!hasLabel) {
        const label = document.createElement('label'); label.className = 'visually-hidden'; label.htmlFor = input.id; label.textContent = 'E-Mail-Adresse'; input.parentNode?.insertBefore(label, input);
      }
      const error = form.querySelector('.dns-message--error');
      const success = form.querySelector('.dns-message--success');
      if (error) {
        error.id ||= `${input.id}-error`; error.setAttribute('role','alert'); error.setAttribute('aria-live','assertive'); input.setAttribute('aria-invalid','true'); appendDescribedBy(input,error.id);
      } else input.removeAttribute('aria-invalid');
      if (success) { success.id ||= `${input.id}-success`; success.setAttribute('role','status'); success.setAttribute('aria-live','polite'); }
    });
  };

  const enhanceHeader = (root = document) => {
    root.querySelectorAll('[data-dayvee-header]').forEach((header) => {
      const drawer = header.querySelector('[data-dyh-drawer]');
      const openButton = header.querySelector('[data-dyh-open]');
      if (drawer) { if (!drawer.id) { idCounter += 1; drawer.id = `dayvee-mobile-menu-${idCounter}`; } openButton?.setAttribute('aria-controls',drawer.id); }
      header.querySelectorAll('[data-dyh-search-input]').forEach((input) => { input.removeAttribute('aria-autocomplete'); input.removeAttribute('aria-haspopup'); });
      header.querySelectorAll('[data-dyh-predictive-panel]').forEach((panel) => panel.setAttribute('role','region'));
    });
  };

  const enhanceMegaMenu = (root = document) => {
    root.querySelectorAll('[data-dayvee-mega-menu]').forEach((menu) => {
      menu.querySelectorAll('[data-dmm-tab]').forEach((tab) => {
        const key = tab.getAttribute('data-dmm-tab');
        const panel = key ? Array.from(menu.querySelectorAll('[data-dmm-panel]')).find((candidate) => candidate.getAttribute('data-dmm-panel') === key) : null;
        tab.removeAttribute('aria-haspopup');
        if (panel) {
          if (!panel.id) { idCounter += 1; panel.id = `dayvee-mega-panel-${idCounter}`; }
          tab.setAttribute('aria-controls',panel.id); panel.setAttribute('role','region'); panel.setAttribute('aria-label',(tab.textContent || '').replace(/\s+/g,' ').trim());
        }
      });
    });
  };

  const updateHeaderActionLabels = (root = document) => {
    root.querySelectorAll('[data-dayvee-header]').forEach((header) => {
      header.querySelectorAll('[data-dyh-cart-open]').forEach((link) => {
        const count = Number(link.querySelector('.dyh-cart-badge')?.textContent?.trim() || 0);
        link.setAttribute('aria-label',count > 0 ? `Warenkorb, ${count} Artikel` : 'Warenkorb');
      });
      header.querySelectorAll('[data-dayvee-merkliste-link]').forEach((link) => {
        const count = Number(link.querySelector('[data-dayvee-merkliste-count]')?.textContent?.trim() || 0);
        link.setAttribute('aria-label',count > 0 ? `Merkliste, ${count} ${count === 1 ? 'Produkt' : 'Produkte'} gemerkt` : 'Merkliste');
      });
    });
  };

  const getFocusable = (container) => Array.from(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')).filter((element) => {
    const style = window.getComputedStyle(element); return style.visibility !== 'hidden' && style.display !== 'none' && element.getClientRects().length > 0;
  });

  const handleGlobalKeydown = (event) => {
    if (event.key === 'Tab') {
      const drawer = document.querySelector('[data-dyh-layer].is-open')?.querySelector('[data-dyh-drawer]');
      if (drawer) {
        const focusable = getFocusable(drawer);
        if (!focusable.length) { event.preventDefault(); drawer.focus(); return; }
        const first = focusable[0], last = focusable[focusable.length - 1], active = document.activeElement;
        if (event.shiftKey && (active === first || !drawer.contains(active))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (active === last || !drawer.contains(active))) { event.preventDefault(); first.focus(); }
      }
    }
    if (event.key === 'Escape') {
      const openMenu = document.querySelector('[data-dayvee-mega-menu] .dmm-panel-shell.is-open');
      const activeTab = openMenu?.closest('[data-dayvee-mega-menu]')?.querySelector('[data-dmm-tab].is-active');
      if (activeTab) window.setTimeout(() => activeTab.focus(),0);
    }
  };

  const enhanceAll = (root = document) => { injectStyles(); enhanceNewsletter(root); enhanceHeader(root); enhanceMegaMenu(root); updateHeaderActionLabels(root); };
  const start = () => {
    enhanceAll(document); document.addEventListener('keydown',handleGlobalKeydown,true);
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => node.nodeType === Node.ELEMENT_NODE))) { enhanceNewsletter(document); enhanceHeader(document); enhanceMegaMenu(document); }
      updateHeaderActionLabels(document);
    });
    observer.observe(document.body,{childList:true,subtree:true,characterData:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',(event) => enhanceAll(event.target || document));
})();

/* DAYVEE ACCESSIBILITY – PRODUKT, ROUTINE-MODAL UND QUIZ */
(() => {
  const STYLE_ID = 'dayvee-product-accessibility-style';
  const MODAL_SELECTOR = '.dayvee-product__image-modal:not([hidden]),.dayvee-product__modal:not([hidden]),.dayvee-product__question-modal:not([hidden]),.drm__overlay.is-open .drm__panel';

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style'); style.id = STYLE_ID;
    style.textContent = `
      .dayvee-product :where(a,button,summary,[role="tab"],[role="button"]):focus-visible,.dayvee-cart :where(a,button,summary,[role="button"]):focus-visible,.dayvee-merkliste :where(a,button,summary):focus-visible,.dayvee-search :where(a,button,summary):focus-visible,.drm :where(a,button):focus-visible{outline:2px solid #fff!important;outline-offset:2px!important;box-shadow:0 0 0 4px #0058bd!important}
      .dayvee-product :where(input,select,textarea):focus-visible,.dayvee-cart :where(input,select,textarea):focus-visible,.dayvee-merkliste :where(input,select,textarea):focus-visible,.dayvee-search :where(input,select,textarea):focus-visible{outline:2px solid #fff!important;outline-offset:1px!important;box-shadow:0 0 0 4px #0058bd!important}
    `;
    document.head.appendChild(style);
  };

  const enhanceInteractiveAreas = (root = document) => {
    root.querySelectorAll('.dayvee-product__thumb-button').forEach((button) => button.setAttribute('aria-pressed',button.classList.contains('is-active') ? 'true' : 'false'));
    root.querySelectorAll('.dayvee-product__stock').forEach((status) => { status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.setAttribute('aria-atomic','true'); });
    root.querySelectorAll('.dayvee-product__question-message--success').forEach((message) => { message.setAttribute('role','status'); message.setAttribute('aria-live','polite'); message.setAttribute('aria-atomic','true'); });
    root.querySelectorAll('.dyv-routine-flow__quiz').forEach((quiz) => { quiz.setAttribute('role','region'); quiz.setAttribute('aria-label','Routine-Finder'); });
    root.querySelectorAll('.drm__loading').forEach((status) => { status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.setAttribute('aria-atomic','true'); });
    root.querySelectorAll('.drm__error').forEach((error) => { error.setAttribute('role','alert'); error.setAttribute('aria-live','assertive'); });
  };

  const getVisibleModal = () => Array.from(document.querySelectorAll(MODAL_SELECTOR)).find((modal) => {
    const style = window.getComputedStyle(modal);
    return modal.getAttribute('aria-hidden') !== 'true' && style.display !== 'none' && style.visibility !== 'hidden';
  }) || null;
  const getFocusable = (container) => Array.from(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')).filter((element) => {
    const style = window.getComputedStyle(element); return style.visibility !== 'hidden' && style.display !== 'none' && element.getClientRects().length > 0;
  });

  const trapModalFocus = (event) => {
    if (event.key !== 'Tab') return;
    const modal = getVisibleModal();
    if (!modal) return;
    const focusable = getFocusable(modal);
    if (!focusable.length) { event.preventDefault(); if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex','-1'); modal.focus(); return; }
    const first = focusable[0], last = focusable[focusable.length - 1], active = document.activeElement;
    if (event.shiftKey && (active === first || !modal.contains(active))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (active === last || !modal.contains(active))) { event.preventDefault(); first.focus(); }
  };

  const start = () => {
    injectStyles(); enhanceInteractiveAreas(document); document.addEventListener('keydown',trapModalFocus,true);
    document.addEventListener('click',(event) => { if (event.target.closest('.dayvee-product__thumb-button')) window.setTimeout(() => enhanceInteractiveAreas(document),0); });
    document.addEventListener('dayvee:variant-change',() => window.setTimeout(() => enhanceInteractiveAreas(document),0));
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => {
        const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
        if (target?.closest?.('.dayvee-product,.drm,.dyv-routine-flow')) return true;
        return Array.from(mutation.addedNodes).some((node) => node.nodeType === Node.ELEMENT_NODE && (node.matches?.('.dayvee-product,.dayvee-product *,.drm,.drm *,.dyv-routine-flow,.dyv-routine-flow *') || node.querySelector?.('.dayvee-product,.drm,.dyv-routine-flow')));
      })) enhanceInteractiveAreas(document);
    });
    observer.observe(document.body,{childList:true,subtree:true,characterData:true});
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',(event) => { injectStyles(); enhanceInteractiveAreas(event.target || document); });
})();

/* DAYVEE ACCESSIBILITY – FOOTER */
(() => {
  const STYLE_ID = 'dayvee-footer-accessibility-style';
  let headingCounter = 0;

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      [id^="dayvee-premium-footer-"] .dpf-bottom{color:#E6EEFB!important}
      [id^="dayvee-premium-footer-"] .dpf-social[hidden]{display:none!important}
    `;
    document.head.appendChild(style);
  };

  const enhanceFooter = (root = document) => {
    root.querySelectorAll('.dayvee-premium-footer').forEach((footer) => {
      footer.setAttribute('role','contentinfo');
      footer.setAttribute('aria-label','Fußbereich');

      [
        ['.dpf-col--service','Service und Kontakt'],
        ['.dpf-col--legal','Rechtliches'],
        ['.dpf-col--links','Weitere Links']
      ].forEach(([selector, fallback]) => {
        const column = footer.querySelector(selector);
        if (!column) return;
        const heading = column.querySelector('.dpf-heading');
        column.setAttribute('role','navigation');
        if (heading) {
          if (!heading.id) { headingCounter += 1; heading.id = `dayvee-footer-heading-${headingCounter}`; }
          column.setAttribute('aria-labelledby',heading.id);
        } else column.setAttribute('aria-label',fallback);
      });

      const socials = Array.from(footer.querySelectorAll('.dpf-social'));
      socials.forEach((link) => {
        const href = (link.getAttribute('href') || '').trim();
        if (!href || href === '#') link.hidden = true;
      });
      const socialWraps = Array.from(footer.querySelectorAll('.dpf-socials'));
      socialWraps.forEach((wrap) => {
        const hasVisible = Array.from(wrap.querySelectorAll('.dpf-social')).some((link) => !link.hidden);
        if (!hasVisible) wrap.hidden = true;
      });
    });
  };

  const init = (root = document) => { injectStyles(); enhanceFooter(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',(event) => init(event.target || document));
})();

/* DAYVEE NEWSLETTER – ERFOLGSMELDUNG SICHTBAR POSITIONIEREN */
(() => {
  const positionSuccess = () => {
    const message = document.querySelector('.section-dayvee-newsletter-split .dns-message--success');
    if (!message) return false;
    message.scrollIntoView({ behavior: 'auto', block: 'center' });
    try { message.focus({ preventScroll: true }); } catch { message.focus(); }
    return true;
  };

  const settleSuccessPosition = () => {
    if (!positionSuccess()) return;
    requestAnimationFrame(() => {
      positionSuccess();
      requestAnimationFrame(positionSuccess);
    });
    [160, 520, 980, 1380].forEach((delay) => window.setTimeout(positionSuccess, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', settleSuccessPosition, { once: true });
  } else {
    settleSuccessPosition();
  }

  window.addEventListener('pageshow', () => window.setTimeout(positionSuccess, 0));
})();
